var _defs, _path, _ellipse, _g, _path2, _g2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed5145;}.cls-2{fill:#ff715d;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#fff;}.cls-7{fill:#f4e211;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1146.31,
    cy: 402.46,
    rx: 128.71,
    ry: 267.39,
    transform: "translate(-67.9 361.26) rotate(-17.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M830,321.8c-5.76-29-40.64-41.12-70.16-43.31-113.07-8.37-228.29,55.4-281.22,155.67-46-13.69-94.93-12-142.86-10.27-17.16.64-35.35,1.6-49.51,11.31-20.21,13.88-25.82,40.77-29.41,65Q242.38,598.1,236.45,697c-1.55,25.89-1,55.84,19.06,72.33,19.27,15.86,47.67,11.71,71.73,5.06A545.16,545.16,0,0,0,538.82,660.66c47.73,32.76,111.85,40.18,165.79,19.19s96.19-69.79,109.23-126.19c87.34,37.66,198.56,8.6,256.31-67-46.06-68.27-53.12-161-17.92-235.5,7.75-16.39,17.45-32.13,21.64-49.78,7.16-30.2-3.8-58.19-36.47-50.71-30.07,6.88-59.26,19.8-85.58,35.75a318.57,318.57,0,0,0-71.57,59.16A306.26,306.26,0,0,0,851.41,283C846.8,290.06,828.33,313.38,830,321.8Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.67,872c37.14,26.55,87.6,33.35,130.45,17.59s76.18-51.48,119.54-65.48c57.82-18.67,124.54,4.09,179.77-21.26,28.56-13.11,50.51-37.76,78.8-51.46,67.12-32.49,149.53,4.07,220.88-17.62,27-8.21,52.36-26,63.34-52,14.41-34.14,1.64-73-11.17-107.82-10.92-29.69-23.41-61.4-49.87-78.73-28.67-18.79-65.89-15.69-100-11.87-126,14.12-252.84,28.66-373.61,67.16-66.08,21.06-130.13,49.63-188.24,87.68A581.18,581.18,0,0,0,347.22,703c-23.54,22.4-50.29,41.69-44.63,76.26C308.6,816,329.36,850.3,359.67,872Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1146.31,
    cy: 402.46,
    rx: 128.71,
    ry: 267.39,
    transform: "translate(-67.9 361.26) rotate(-17.4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 1158.82,
    cy: 383.5,
    rx: 34.39,
    ry: 77.27,
    transform: "translate(-57.43 280.15) rotate(-13.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1080.27,501.05s20.3,68.33,78.55,136.06"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1159.91,
    cy: 384.96,
    rx: 13.6,
    ry: 34.33,
    transform: "translate(-57.74 280.44) rotate(-13.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1250.87,385.48s48.61,201.79-30.26,232.06"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M830,321.8c-5.76-29-40.64-41.12-70.16-43.31-113.07-8.37-228.29,55.4-281.22,155.67-46-13.69-94.93-12-142.86-10.27-17.16.64-35.35,1.6-49.51,11.31-20.21,13.88-25.82,40.77-29.41,65Q242.38,598.1,236.45,697c-1.55,25.89-1,55.84,19.06,72.33,19.27,15.86,47.67,11.71,71.73,5.06A545.16,545.16,0,0,0,538.82,660.66c47.73,32.76,111.85,40.18,165.79,19.19s96.19-69.79,109.23-126.19c87.34,37.66,198.56,8.6,256.31-67-46.06-68.27-53.12-161-17.92-235.5,7.75-16.39,17.45-32.13,21.64-49.78,7.16-30.2-3.8-58.19-36.47-50.71-30.07,6.88-59.26,19.8-85.58,35.75a318.57,318.57,0,0,0-71.57,59.16A306.26,306.26,0,0,0,851.41,283C846.8,290.06,828.33,313.38,830,321.8Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M558.39,630.14c11.24,5.05,59.84,25.39,117.71,6.36,63.2-20.78,90.24-73,95.08-82.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M862.44,524.61a195,195,0,0,0,175.06-44.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M996,186.32a179.6,179.6,0,0,0-28.64,19c-3.8,3.08-7.82,8.13-5.26,12.29,1.88,3.06,6.42,3.35,9.64,1.77s5.52-4.5,8.06-7c3.34-3.34,9.25-6,12.35-2.42,2.25,2.58,1.11,6.75-1.16,9.32s-5.41,4.21-7.79,6.67-3.91,6.41-2,9.28c1.69,2.59,5.48,3.07,8.34,1.89s5-3.57,7-5.9l13.61-15.52c1.85-2.11,3.84-4.79,3-7.46-.71-2.24-3.14-3.45-4.33-5.47-2.31-3.92,1.08-9,5.25-10.87s8.92-1.72,13.27-3.08,8.63-5.27,7.75-9.73c-.59-3-3.42-5.16-6.4-5.81s-6.09-.08-9.05.66A82.24,82.24,0,0,0,978,199.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M747.33,308.83c-13.76,2-18.52,4.19-28.24,13.51-1.59,1.53-3.14,3.27-3.32,5.58a3.83,3.83,0,0,0,1.62,3.56c2.51,1.64,5.58-.74,8-2.51a21.77,21.77,0,0,1,17-3.67c-1.07,3.15-4.51,4.68-7.24,6.59-2.89,2-5.34,6.23-2.58,8.85a4.58,4.58,0,0,0,5.24.55c3.56-1.83,4.62-5.59,6.49-8.74a20.42,20.42,0,0,1,18.9-9.7c3.16.27,6.35,1.3,9.44,0a4.74,4.74,0,0,0,2.84-3.22c.73-3.22-2.52-5.12-5.28-4.82-2.25.24-4.22,1.56-6.1,2.84l5-4.2a3.3,3.3,0,0,0-2.34-5.81l-19.86,1.24"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M455,633.27c22,78.53,71.25,149,136.07,194.38-48.55-66.68-80-146.12-96.18-227.81a695,695,0,0,1-12.65-106.22c-.46-11.26,3.44-78.52-25.46-56.66-15.94,12.06-14.73,75.39-15,94.63A362,362,0,0,0,455,633.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M860.35,691.77c15.17,22.15,35.17,44.44,61.84,47.62C842,628.1,806.45,485.6,824.9,349.69c1-7.39,6.41-36.34-3.51-39.5-10.62-3.38-16.58,18-18.47,24-9,28.49-13.28,59.14-15.13,88.87a438.36,438.36,0,0,0,26.34,179.1A413.48,413.48,0,0,0,860.35,691.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects03);
export default __webpack_public_path__ + "static/media/objects-03.836f1526c0e74de774f4d4bf9cc020ab.svg";
export { ForwardRef as ReactComponent };